/**
 * Voyant de connexion temps réel - OBSERVATEUR du socket global.
 *
 * N'ouvre AUCUNE connexion : il regarde celle que socketService a déjà ouverte.
 *
 * C'est le point central : un voyant qui surveillerait sa PROPRE liaison pourrait
 * être vert pendant que le socket de l'application est mort. Pour dire la vérité,
 * il doit observer le socket qui porte réellement le trafic. Accessoirement, cela
 * ne coûte plus rien au serveur - aucune connexion supplémentaire.
 *
 * Le socket est créé par l'action `initializeSocket` du store, dispatchée depuis
 * `chektoken` (store_app.js:1415), donc à chaque navigation. `socketService
 * .initializeSocket()` est idempotent : rien à réinitialiser ici.
 */

import { socketService } from '@/service/socketService';

/** Le socket est créé par chektoken ; rien ne garantit l'ordre vis-à-vis du montage. */
const ATTENTE_MS = 400;

export class PresenceSocket {
    constructor() {
        this.onEtat = null;
        this.socket = null;
        this.timer = null;
        this.h = null;
    }

    /**
     * @param {(etat: 'connexion'|'connecte'|'reconnexion') => void} onEtat
     */
    observer(onEtat) {
        this.onEtat = onEtat;
        this.onEtat('connexion');
        this._attacher();
    }

    _attacher() {
        const s = socketService.socket;

        console.log("PresenceSocket _attacher ********* ")
        console.log("PresenceSocket socketService.socket ********* ",socketService.socket)
        console.log("PresenceSocket s ********* ",s)

        if (!s) {
            this.timer = setTimeout(() => this._attacher(), ATTENTE_MS);
            return;
        }
        this.socket = s;

        console.log("PresenceSocket _attacher socket ********* ",this.socket)

        /* Handlers NOMMÉS, et non des lambdas anonymes : sans référence conservée,
           impossible de les retirer un par un au démontage - et un
           removeAllListeners() emporterait aussi ceux de socketService. */
        this.h = {
            connect: () => { if (this.onEtat) this.onEtat('connecte'); },
            disconnect: () => { if (this.onEtat) this.onEtat('reconnexion'); },
            connect_error: () => { if (this.onEtat) this.onEtat('reconnexion'); },
        };
        s.on('connect', this.h.connect);
        s.on('disconnect', this.h.disconnect);
        s.on('connect_error', this.h.connect_error);

        /* Le socket est probablement DÉJÀ connecté quand on arrive ici : l'événement
           'connect' est passé depuis longtemps et ne se rejouera pas. Sans cette
           ligne, le voyant resterait gris sur une liaison parfaitement saine. */
        this.onEtat(s.connected ? 'connecte' : 'connexion');
    }

    /**
     * Transport réellement négocié : 'websocket' ou 'polling'.
     *
     * socketService impose `transports: ['websocket']`, sans repli polling : en
     * pratique ce sera donc toujours 'websocket' - ou rien du tout si le reverse
     * proxy ne relaie pas l'Upgrade, auquel cas le socket ne se connecte pas.
     */
    transport() {
        const s = this.socket;
        if (!s || !s.io || !s.io.engine || !s.io.engine.transport) return '';
        return s.io.engine.transport.name || '';
    }

    connecte() {
        return !!(this.socket && this.socket.connected);
    }

    /**
     * Retire UNIQUEMENT nos écouteurs.
     *
     * ⚠️ Ne JAMAIS appeler disconnect() ni removeAllListeners() ici : le socket
     * appartient à l'application, pas au voyant. Le démonter couperait le temps
     * réel de toute l'application au premier changement de page.
     */
    arreter() {
        if (this.timer) { clearTimeout(this.timer); this.timer = null; }
        if (this.socket && this.h) {
            this.socket.off('connect', this.h.connect);
            this.socket.off('disconnect', this.h.disconnect);
            this.socket.off('connect_error', this.h.connect_error);
        }
        this.h = null;
        this.socket = null;
        this.onEtat = null;
    }
}
